export default "__VITE_ASSET__BtqKw55E__"